import { Injectable } from '@angular/core';
import { VariantBase } from './ecom-variantbase';
import { ModifierSetBase } from './ecom-modifersetbase';
import { Discount } from '@src/app/ecom-models/discount';
import { Reward } from '@src/app/ecom-models/reward';

@Injectable()
export class ItemBase {
    itemsPerDiscount: number;
    earning_points: boolean;

    has_benefit_count:boolean;
    guid = '';
    itemId = 0;
    itemModId = '';
    itemGuid = '';
    imagePath = '';
    imageColor = '';
    itemName = '';
    itemAlternativeName: '';
    itemDescription = '';
    variantList: VariantBase[] = [];
    modifierSetList: ModifierSetBase[] = [];
    specialRequest = '';
    quantity = 0;
    priceEach = 0;
    // Item price and modiers price
    totalPrice = 0;
    // Selected Modifiers only
    totalModifersPrice = 0;
    taxEach = 0;
    totalTax = 0;
    isValid = true;
    itemError = '';
    HasModifier = false;
    salePrice = 0;
    priceEachAfterDiscount = 0;
    priceEachBeforeDiscount = 0;
    totalPriceAfterDiscount = 0;
    totalPriceBeforeDiscount = 0;
    totalDiscountAmount = 0;
    discountPercentage = 0;
    ItemVariantModifierSetOptionGuid = '';

    // Diem Added
    discounts: Discount[] = [];
    reward: Reward;
    has_discount = 0;
    selectedDiscountId: number;
    percentageAmount: number;
    fixedAmount: number;

    discounted: boolean = false;
    discountedItems: number;
    autoDiscountPrice: number = 0;
    fullPriceItems: number;
    buyGetItems: ItemBase[] = [];

    combinationGetItems: ItemBase[] = [];

    combinationBuyItems: ItemBase[] = [];

    itemsDiscounted: ItemBase[] = []; // for minimum required non and 1
    isFree: boolean = false;
    discountName: string;

    // upsell
    iuic_pkid: number = 0;

    discountAmount: number = 0;
    discountedPrice: number = 0;
    tax: any;

    priceEachBeforeTax: number = 0;
    itemModifierPrice = 0;
    originalItem: ItemBase = null;

    addedByUser = true;
    index: number = 0;

    parentGuid = '';

    canRemove = true;

    hasReward = false;

    // using this prop in combination popup
    itemIndex = 0;

    isBuyItem = false;
    isFirstBuy = false
    isFirstGet = false;
    iscvsd_pkid: number;
    constructor(data?: Partial<ItemBase>) {
        Object.assign(this, data);
        this.guid = generateGuid();
        this.originalItem = null;
    }
}

export function generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
